<table class="diff">
  <tr *ngIf="hasHeader">
    <th>{{ leftHeader }}</th>
    <th>{{ rightHeader }}</th>
    <th>{{ compareHeader }}</th>
  </tr>
  <tr>
    <td>
      <pre>{{ left }}</pre>
    </td>
    <td class="middle">
      <pre>{{ right }}</pre>
    </td>
    <td>
      <pre id="{{ resultid }}"></pre>
    </td>
  </tr>
</table>
